import { React, useEffect, useState } from "react"
import { VerticalTimelineElement }  from 'react-vertical-timeline-component';
import { FaFlag } from 'react-icons/fa';
import { BsFullscreen, BsFullscreenExit } from 'react-icons/bs';
import Carousel from 'react-gallery-carousel';
import 'react-gallery-carousel/dist/index.css';
import parse from 'html-react-parser';

export default function Element(props) {

    const [display, setDisplay] = useState(false);

    const open = () => {
        setDisplay(true);
    }

    const close = () => {
        setDisplay(false);
    }

    const images = props.images.map((image, key) => ({
        src: image.url
    }));

    if(display) {
        // check image usage
        if(props.images.length > 0) {
            return (
                <VerticalTimelineElement
                    date={props.title}
                    icon={<FaFlag/>} >
                    <div>
                        <div className="header" style={{cursor: 'pointer'}} >
                            <h2 onClick={() => close()}>{props.header}</h2>
                        </div>
                        <div className="content" >{parse(props.content)}</div>
                        <Carousel images={images} style={{marginTop: 20, backgroundColor: 'white', color: '#d20000'}} 
                            hasMediaButton={false} 
                            hasIndexBoard={false}
                        />
                    </div>
                </VerticalTimelineElement>
            );
        } else {
            return (
                <VerticalTimelineElement
                    date={props.title}
                    icon={<FaFlag/>} >
                    <div>
                        <div className="header" style={{cursor: 'pointer'}} >
                            <h2 onClick={() => close()}>{props.header}</h2>
                        </div>
                        <div className="content" >{parse(props.content)}</div>
                    </div>
                </VerticalTimelineElement>
            );
        }
    } else {
        return (
            <VerticalTimelineElement
                    date={props.title}
                    icon={<FaFlag/>} >
                <div className="header" style={{cursor: 'pointer'}} >
                    <h2 onClick={() => open()}>{props.header}</h2>
                </div>
            </VerticalTimelineElement>
        );
    }

}